const INTRO = `I am a trusted team player with proven development team lead and
              management skills. I have worked in the US, Canada and Switzerland in
              multi-national environments and Fortune 500 companies across a wide range of industries.
              In addition, I have almost twenty years experience designing and architecting applications using web, SAP,
              and mobile technologies.`;

const JOBS = [
  {
    companyName: "ConvergentIS",
    country: "Canada",
    thumbnail: "images/convergent.png",
    title: "Senior Designer and Developer",
    startDate: new Date("2016-09-01"),
    endDate: "Present",
    responsibilities: [
      `A cross functional team player working with companies accross their design
      process from Design Sprint sessions through to the realization of full stack React and UI5 frontend and backend SAP builds.`
    ]
  },

  {
    companyName: "ConvergentIS - CP Rail",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2019-05-01"),
    endDate: "Present",
    responsibilities: [`Design and develop custom HR management applications`]
  },
  {
    companyName: "ConvergentIS - Internal",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2019-03-01"),
    endDate: new Date("2019-04-01"),
    responsibilities: [`Develop customizable business rules engine.`]
  },

  {
    companyName: "ConvergentIS - TransCanada",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2018-07-01"),
    endDate: new Date("2019-02-01"),
    responsibilities: [
      `Helped run Design Sprint Sessions to rapidly protype and design an application.  Led the development team to build and deploy the offline hybrid iOS and Android safety reporting application.

      `
    ]
  },

  {
    companyName: "ConvergentIS - Internal",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2018-07-01"),
    endDate: new Date("2018-07-01"),
    responsibilities: [
      "Designed and built a serverless (AWS Lambda) React and Apollo GraphQL agile sprint Management tool for use with Microsoft DevOps"
    ]
  },

  {
    companyName: "ConvergentIS - FitBit",
    country: "United States",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2018-02-01"),
    endDate: new Date("2018-07-01"),
    responsibilities: [
      "Customized a purchasing application to replace the standard application that was both easier to use and sped the time to entry of purchase requisitions."
    ]
  },
  {
    companyName: "ConvergentIS - CP Rail",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2017-06-01"),
    endDate: new Date("2018-02-01"),
    responsibilities: [
      "Re-designed and developed a modern incident management system with customized web UI5 application for tracking all safety events across the organization."
    ]
  },

  {
    companyName: "ConvergentIS - Fortis Alberta",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2017-05-01"),
    endDate: new Date("2017-06-15"),
    responsibilities: [
      "Designed and built a prototype incident management tracking system"
    ]
  },
  {
    companyName: "ConvergentIS - ATB Financial",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2017-03-01"),
    endDate: new Date("2017-06-01"),
    responsibilities: [
      "Designed and developed UI5 custom SAP Banking applications for displaying client details",
      "Developed SAP My Inbox custom approvals"
    ]
  },
  {
    companyName: "ConvergentIS - Enerflex",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2017-03-01"),
    endDate: new Date("2017-06-01"),
    responsibilities: [
      "Enhanced HCM appraisal process",
      "Built and deployed a T4 Tax form fiori tile for employee self service",
      "Created a manager application to view all of their teams details"
    ]
  },

  {
    companyName: "ConvergentIS - Veresen",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2017-02-01"),
    endDate: new Date("2017-03-31"),
    responsibilities: ["Migrated portal from on premise to SAP Cloud Platform"]
  },
  {
    companyName: "ConvergentIS - City of Vancouver",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2017-01-01"),
    endDate: new Date("2017-03-01"),
    responsibilities: [
      "Deployed and enhanced MM goods issue/goods receipt applications"
    ]
  },

  {
    companyName: "ConvergentIS - CP Rail",
    country: "Canada",
    thumbnail: "images/convergent.png",
    // title: "Senior Designer and Developer",
    startDate: new Date("2016-09-01"),
    endDate: new Date("2016-12-31"),
    responsibilities: [
      "Designed and developed ABAP oData services for a complete HCM Performance Management application with real time analytics for over 5000 employees",
      "Developed real time reporting for managers on the status of all appraisals",
      "Built applications using SAP Cloud Portal, Gateway and API as a service"
    ]
  },

  {
    companyName: "Zenpare Inc.",
    country: "Canada",
    thumbnail: "images/zenpare2.png",
    title: "Software Developer",
    startDate: new Date("2015-07-01"),
    endDate: new Date("2016-08-01"),
    responsibilities: ["Developed React custom projects."]
  },
  {
    companyName: "Nestlé",
    country: "Switzerland",
    title: "Software Architect",
    thumbnail: "./images/nestle-logo-google.png",
    startDate: new Date("2013-01-02"),
    endDate: new Date("2015-06-30"),
    responsibilities: [
      "Led a team of onshore and offshore developers for a customized project management system (PPM/RPM and cProjects)",
      "Developed an SAP UI5 project management application for deliverables creation and review",
      "Developed a kanban board for agile project management in angularjs and became an angular-ui contributor"
    ]
  },
  {
    companyName: "PMI - Prinz and Partner",
    country: "Switzerland",
    thumbnail: "./images/philip-morris-international.png",
    title: "Development Consultant at Philip Morris International",
    startDate: new Date("2010-11-02"),
    endDate: new Date("2012-12-31"),
    responsibilities: [
      "Designed and developed a secure web based mobile approval system used globally (jQuery and REST services)",
      "Updated the design of business critical workflows used by over one hundred thousand approvals a year",
      "Developed a .NET Silverlight web based interface for self service requests in an SAP system",
      "Built a universal worklist application --  a central location for thousands of simultaneous users to see new tasks in near real-time across SAP and non-SAP systems",
      "Technical lead of a cross functional upgrade project from SAP ECC5 to ERP 6"
    ]
  },
  {
    companyName: "Owens-Illinois",
    country: "Switzerland",
    thumbnail: "images/o-i.jpg",
    title: "SAP Development Team Lead",
    startDate: new Date("2007-01-02"),
    endDate: new Date("2010-10-31"),
    responsibilities: [
      "Lead of European custom development team (ABAP/PI)",
      "Responsible for the architecture, design, development and maintenance of all reports, interfaces, conversions, forms and workflows",
      "Responsible for the management of a team of five onsite and offshore developers",
      "Performed code reviews and release to production decisions",
      "Reduced the number of development incidents by 25% since joining the project including significantly reducing the number of workflows open and in error",
      "Completed development roll-outs to four countries of the PP, MM, SD, FI/CO, and APO modules",
      "Performed impact analysis for migration from ECC5 to ERP 6 for all custom developments",
      "Integrated Adobe Flex components and Adobe Interactive Form developments with ABAP Web Dynpro applications"
    ]
  },

  {
    companyName: "PMI - Blue Infinity",
    country: "Switzerland",
    thumbnail: "./images/philip-morris-international.png",
    // thumbnail: 'images/blue-infinity.png',
    title: " SAP Developer at Philip Morris International",
    startDate: new Date("2005-08-02"),
    endDate: new Date("2007-01-30"),
    responsibilities: [
      "Supported country roll-outs, gathered business requirements to design technical specifications, developed technical objects, handled and delegated support requests to offshore team, managing changes from design phase through to production",
      "Developed in MM, QM, PP and Document Management modules",
      "Supported workflow, ALE/IDOCs, and interfacing issues"
    ]
  },
  {
    companyName: "Accenture",
    country: "Canada, United States",
    thumbnail: "images/accenture_logo_only.png",
    title: "SAP Consultant",
    startDate: new Date("2001-09-02"),
    endDate: new Date("2005-07-31"),
    responsibilities: [
      `Worked for a wide variety of clients solving complex business problems using various technologies
      with a primary focus on SAP ABAP development and application design.
      Worked directly at SAP developing industry specific components`,
      "Clients included SAP, Enbridge, DynoNobel, Purolator, BC Hydro and Universal Studios"
    ]
  },
  {
    companyName: "Weisshuhn & Weisshuhn",
    thumbnail: "images/weisshuhn.jpg",
    country: "Germany",
    title: "Web Developer",
    startDate: new Date("2000-06-02"),
    endDate: new Date("2000-08-30"),
    responsibilities: [
      "Developed Java apps that interfaced with a CORBA backend in a Linux/UNIX development environment",
      "Used XML and the DOM to generate dynamic web pages. Also worked with CSS, JavaScript, and HTML"
    ]
  },
  {
    companyName: "Eclipse Web Solutions",
    country: "Canada",
    thumbnail: "images/eclipse.jpg",
    title: "Contract Design",
    startDate: new Date("1999-09-02"),
    endDate: new Date("2000-05-30"),
    responsibilities: [
      "Contracted to design web pages using Photoshop, HTML, ASP, and JavaScript"
    ]
  },
  {
    companyName: "National Research Council",
    thumbnail: "images/nrc.png",
    country: "Canada",
    title: "Developer",
    startDate: new Date("1999-05-02"),
    endDate: new Date("1999-09-30"),
    responsibilities: [
      "Programmed applications using Apache, Perl and JAVA on Unix and Linux systems",
      "Configured and optimized a search engine to index over 100 000 documents and helped author internal Linux security document"
    ]
  }
];

const SKILLS = [
  {
    name: "Full Stack Development",
    list:
      "JavaScript, Node, React, TensorFlow JS, TypeScript, AngularJS (1.x), d3, cloud deployment (AWS and AWS Lambda/serverless), Linux, HTML5, Sass/CSS, SQL, GraphQL, webpack/parcel"
  },
  {
    name: "Machine and Deep Learning",
    list: "Tensorflow JS, Keras, basic Python"
  },
  {
    name: "SAP",
    list: `UI5, ABAP, oData services, ABAP OO, ALE/IDOCs, ABAP Workflow, Adobe PDF print forms, Smartforms, BSP, ALV Grid, BAPI, RFC,
      SAP Modules - Materials Management (MM), HCM and Appraisals (HR),
      Sales and Distribution (SD), Finance and Controlling (FI/CO), Production Planning (PP),
      Quality Management (QM), Claims Management (FS-CM), Utilities (IS-U), Project and Portfolio Management (RPM/PPM/cProjects)`
  }
];

export { INTRO, JOBS, SKILLS };
